import { render, staticRenderFns } from "./DeleteServiceDialog.vue?vue&type=template&id=78321889&scoped=true"
import script from "./DeleteServiceDialog.vue?vue&type=script&lang=js"
export * from "./DeleteServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78321889",
  null
  
)

export default component.exports